import { useLabsFeature } from './useLabsFeature.js';

const useLabsFeatureEnabled = (feature) => {
  const { isEnabled } = useLabsFeature(feature);
  return isEnabled;
};

export { useLabsFeatureEnabled };
//# sourceMappingURL=useLabsFeatureEnabled.js.map
